// src/reducers/measurementUnitReducer.js

import {types} from '../types/types';

const initialState = {
    editingMeasurementUnit: {
        id: 0,
        name: '',
        realmFk: '',
        status: true,
    },
    availableMeasurementUnits: [] // ← Nuevo estado para filtros
};

export const measurementUnitReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.editingMeasurementUnitInfo:
            return {
                ...state,
                editingMeasurementUnit: action.payload,
            };

        case types.clearMeasurementUnitInfo:
            return {
                ...state,
                editingMeasurementUnit: initialState.editingMeasurementUnit,
            };

        case types.setAvailableMeasurementUnits:
            return {
                ...state,
                availableMeasurementUnits: action.payload
            };

        default:
            return state;
    }
};